import { useContext, useEffect, useState } from 'react';
import { UseAuthorizedLogisticParties } from '../interfaces/LogisticPartyDetails.interface';
import LPContext from '../context/LPContext';
import {
  addTermIntoStore,
  subscribeToTermStore,
  termsStore,
  unsubscribeFromTermStore,
} from '../utils/termsObserver';

/**
 * Selects and returns the LPDetails from context
 * @returns {LogisticPartyDetailsList , termsList, isFetchAuthorizedLogisticProvidersLoading}
 */
function useAuthorizedLogisticParties(
  term = '',
  userAuthRequired = false
): UseAuthorizedLogisticParties {
  const termKey = `${term}#${+userAuthRequired}`;
  const [terms, setTerms] = useState<string[]>(termsStore);
  const { authorizedLps, isFetchAuthorizedLogisticProvidersLoading } =
    useContext(LPContext);

  useEffect(() => {
    if ((!term && !userAuthRequired) || termsStore.includes(termKey)) return;
    addTermIntoStore(termKey);
    setTerms(termsStore);
  }, [termKey, term, userAuthRequired]);

  useEffect(() => {
    function onTermStoreChange(updatedTermStore: string[]) {
      setTerms([...updatedTermStore]);
    }
    subscribeToTermStore(onTermStoreChange);
    return () => {
      unsubscribeFromTermStore(onTermStoreChange);
    };
  }, []);
  return {
    authorizedLps: authorizedLps[termKey] ?? [],
    terms,
    isFetchAuthorizedLogisticProvidersLoading,
  };
}

export default useAuthorizedLogisticParties;
